export default "__VITE_ASSET__B8XNJV1j__"